


















import { Component, Prop, Vue } from "vue-property-decorator";
import DashboardDataCard from "./DashboardDataCard.vue";
import { IDashboardData } from "@/types/Dashboard.model";
import { MyOptions } from "@/charts/graphData";

@Component({
  components: {
    DashboardDataCard,
  },
})
export default class DashboardCommandesEnCoursCard extends Vue {
  @Prop() public dashboardData!: IDashboardData;
  @Prop() public isTTC!: boolean;
  @Prop() public myOptions!: MyOptions;
  @Prop({ default: "" }) public styleClass!: string;
  @Prop({ default: () => ({}) }) public styleObject!: object;

  get ticketsEtCouverts(): string {
    return this.dashboardData.TicketsEtCouverts["COMMANDES EN COURS"] || "0/0/0";
  }
}
